import { CENTRAL_HUB_BASE_URL } from 'src/environments/base-url';

export const validatePhoneUrl = (): string => `${CENTRAL_HUB_BASE_URL}/phone/validate`;
